// autocomplete.js
import autoComplete from "@tarekraafat/autocomplete.js";

/**
 * Wrapper functions for @tarekraafat/autocomplete.js to define default options
 *
 * @param {*} inputSelector
 * @param {*} autoCompleteOptions
 * @returns
 */

export default function autocomplete(inputSelector, autoCompleteOptions = {}) {
  const instance = new autoComplete({
    selector: inputSelector,
    placeHolder: autoCompleteOptions.placeHolder ?? "Suche...",
    threshold: autoCompleteOptions.threshold ?? 3,
    debounce: autoCompleteOptions.debounce ?? 300,
    searchEngine: autoCompleteOptions.searchEngine ?? "loose",
    data: {
      src: async (query) => {
        // 1) Benutzerdefinierte async-Quelle
        if (autoCompleteOptions.data?.src) {
          return await autoCompleteOptions.data.src(query);
        }
        // 2) Statische Werte (komplett zurückgeben – Filtering macht die Library)
        if (autoCompleteOptions.data?.values) {
          return autoCompleteOptions.data.values;
        }
        return [];
      },
      cache: autoCompleteOptions.data?.cache ?? false,
      keys:
        autoCompleteOptions.data?.keys ??
        (autoCompleteOptions.data?.values &&
        Array.isArray(autoCompleteOptions.data.values) &&
        typeof autoCompleteOptions.data.values[0] === "object"
          ? ["label"]
          : undefined)
    },
    resultsList: {
      destination:
        autoCompleteOptions.resultsList?.destination ?? inputSelector,
      position: autoCompleteOptions.resultsList?.position ?? "afterend",
      tag: autoCompleteOptions.resultsList?.tag ?? "ul",
      id: autoCompleteOptions.resultsList?.id,
      class: autoCompleteOptions.resultsList?.class,
      maxResults: autoCompleteOptions.resultsList?.maxResults ?? 5,
      noResults: autoCompleteOptions.resultsList?.noResults ?? false,
      element: autoCompleteOptions.resultsList?.element,
      tabSelect: autoCompleteOptions.resultsList?.tabSelect ?? true
    },
    resultItem: {
      tag: autoCompleteOptions.resultItem?.tag ?? "li",
      id: autoCompleteOptions.resultItem?.id,
      class: autoCompleteOptions.resultItem?.class,
      element: (item, data) => {
        if (autoCompleteOptions.resultItem?.element) {
          autoCompleteOptions.resultItem.element(item, data);
        } else {
          item.innerHTML = data.match;
        }
      },
      highlight: autoCompleteOptions.resultItem?.highlight ?? false,
      selected: autoCompleteOptions.resultItem?.selected
    },
    submit: autoCompleteOptions.submit ?? false,
    // Diakritika standardmäßig aktivieren, damit Umlaute / Akzente robust gesucht werden
    diacritics: autoCompleteOptions.diacritics ?? true,
    events: autoCompleteOptions.events
  });

  return instance;
}

// Optional: Kompatibilitätsshim
if (typeof window !== "undefined") {
  window.bootstrap = window.bootstrap || {};
  window.bootstrap.Autocomplete = (selector, opts) =>
    autocomplete(selector, opts);
}
